import { AppContext } from 'context/AppContext';
import React, { useState, useContext, useEffect } from 'react';
import 'antd/dist/antd.css';
import { Drawer, Button, Form, Input, message } from 'antd';
import { changePassword } from 'services/user.js';

import FormInput from 'components/form/FormInput';

const EditUserAccountDetails = (props) => {
    let appContext = useContext(AppContext);

    const [form] = Form.useForm();
    const [currentPassMessage, setCurrentPassMessage] = useState(false);
    const [newPassMessage, setNewPassMessage] = useState(false);
    const [errors, setErrors] = useState({});

    const onFinish = (values) => {
        let data = {
            old_password: values.old_password,
            password: values.password,
            password2: values.password2
        };
        changePassword(appContext.defaults.user_id, data)
            .then((res) => {
                message.success(res.data.message);
                props.onCloseEditPassword();
            })
            .catch((err) => {
                // message.error('Current password is not valid');

                let errCode = err.response.data.code;
                let errMessage = err.response.data;
                console.log('errMessage', errMessage);
                let resMsg = {};
                for (let item in errMessage) {
                    resMsg[item] = errMessage[item][0];
                }

                setErrors(resMsg);

                onFinishFailed();
            });
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Faileddd:', errorInfo);
        setCurrentPassMessage(true);
    };

    useEffect(() => {
        if (Object.keys(errors).length) {
            form.validateFields();
        }
    }, [errors]);

    return (
        <>
            <Drawer
                // title="Basic Drawer"
                placement="right"
                onClose={props.onCloseEditPassword}
                visible={props.visibleEditPassword}
                closable={false}
                width={357}
            >
                <div className="change-password-container">
                    <div className="header">
                        <div className="title">Change Password</div>
                    </div>

                    <Form
                        form={form}
                        layout="vertical"
                        name="basic"
                        labelCol={{
                            span: 24
                        }}
                        wrapperCol={{
                            span: 24
                        }}
                        onChange={(e) => {
                            if (Object.keys(errors).length) {
                                console.log(e.target);
                                setErrors({});
                            }
                        }}
                        initialValues={{
                            remember: true
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        {/* <Form.Item
                            label="Current Password"
                            name="old_password"
                            rules={[
                                {
                                    required: true,
                                    message: currentPassMessage
                                        ? 'Current password is not valid'
                                        : 'Please input your current password!'
                                }
                            ]}
                        >
                            <Input.Password />
                        </Form.Item> */}

                        <FormInput
                            label="Current Password"
                            name="old_password"
                            rules={[
                                {
                                    required: true,
                                    message: currentPassMessage
                                        ? 'Current password is not valid'
                                        : 'Please input your current password!'
                                }
                            ]}
                            password={true}
                            errors={errors}
                        />

                        <FormInput
                            label="New Password"
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your new password!'
                                }
                            ]}
                            password={true}
                            errors={errors}
                        />

                        {/* <Form.Item
                            validateStatus="error"
                            help="Should have something"
                            label="New Password"
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your new password!'
                                }
                            ]}
                        >
                            <Input.Password />
                        </Form.Item> */}

                        <FormInput
                            label="Repeat New Password"
                            name="password2"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your new password!'
                                }
                            ]}
                            password={true}
                            errors={errors}
                        />

                        {/* <Form.Item
                            label="Repeat Password"
                            name="password2"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your new password!'
                                }
                            ]}
                        >
                            <Input.Password />
                        </Form.Item> */}

                        <Form.Item
                            wrapperCol={{
                                span: 16
                            }}
                        >
                            <Button
                                style={{ marginTop: '6px' }}
                                type="button"
                                htmlType="submit"
                            >
                                Change Password
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Drawer>
        </>
    );
};

export default EditUserAccountDetails;
